export class QueryDocumentsDto {
    private documentType: String;
    private documentDescription: String;
    private url: String;
    private file: any;
    private extension: string;
    private canDelete: boolean;
    private name:string;
    private amount: number;
    private mandatory: boolean;
    private documents: QueryDocumentsDto[];
   

    constructor(queryDocumentsDto: any) {
        this.documentType = queryDocumentsDto.documentType;
        this.documentDescription = queryDocumentsDto.documentDescription;
        this.url = queryDocumentsDto.url;
        this.file = queryDocumentsDto.file;
        this.extension = queryDocumentsDto.extension;
        this.canDelete = queryDocumentsDto.canDelete; 
        this.name = queryDocumentsDto.name;
        this.amount = queryDocumentsDto.amount;
        this.mandatory = queryDocumentsDto.mandatory;
        this.documents = queryDocumentsDto.documents;
    }

     /**
     * Getter $documents
     * @return {QueryDocumentsDto[]}
     */
    public get $documents(): QueryDocumentsDto[] {
        return this.documents;
    }

     /**
     * Setter $documents
     * @param {QueryDocumentsDto[]} value
     */
    public set $documents(value: QueryDocumentsDto[]) {
        this.documents = value;
    }

    /**
     * Getter $documentType
     * @return {String}
     */
    public get $documentType(): String {
        return this.documentType;
    }

    /**
     * Getter $documentDescription
     * @return {String}
     */
    public get $documentDescription(): String {
        return this.documentDescription;
    }

    /**
     * Getter $url
     * @return {String}
     */
    public get $url(): String {
        return this.url;
    }

    /**
     * Getter $file
     * @return {any}
     */
    public get $file(): any {
        return this.file;
    }

    /**
     * Getter $extension
     * @return {string}
     */
    public get $extension(): string {
        return this.extension;
    }

    /**
     * Getter $canDelete
     * @return {boolean}
     */
    public get $canDelete(): boolean {
        return this.canDelete;
    }

    /**
     * Setter $documentType
     * @param {String} value
     */
    public set $documentType(value: String) {
        this.documentType = value;
    }

    /**
     * Setter $documentDescription
     * @param {String} value
     */
    public set $documentDescription(value: String) {
        this.documentDescription = value;
    }

    /**
     * Setter $url
     * @param {String} value
     */
    public set $url(value: String) {
        this.url = value;
    }

    /**
     * Setter $file
     * @param {any} value
     */
    public set $file(value: any) {
        this.file = value;
    }

    /**
     * Setter $extension
     * @param {string} value
     */
    public set $extension(value: string) {
        this.extension = value;
    }

    /**
     * Setter $canDelete
     * @param {boolean} value
     */
    public set $canDelete(value: boolean) {
        this.canDelete = value;
    }

    public get $name(): string {
        return this.name;
    }
    public set $name(value: string) {
        this.name = value;
    }
    
    /**
     * Getter $amount
     * @return {Number}
     */
    public get $amount():number {
        return this.amount;
    }

    /**
     * Setter $amount
     * @param {number} value
     */
    public set $amount(value:number) {
        this.amount = value;
    }

    /**
     * Getter $mandatory
     * @retrun {boolean}
     */
    public get $mandatory():boolean{
        return this.mandatory
    }

    /**
     * Setter $mandatory
     * @param {boolean} value
     */
    public set $mandatory(value:boolean){
        this.mandatory = value;
    }
}